import { Messages } from '../../../codegen/Localize';
import { getPathFromUrl } from '../../../ts/helpers/UrlHelpers';
import { ContentSpaceDefinitions } from '../../../ts/models/ContentDefinitions';
import {
  INamedItemInfo,
  ISpaceTypeInfo
} from '../../../ts/models/resourceInfoParts';
import { updateBreadcrumbHref } from '../../actions/UpdateBreadcrumbHref';
import { updateBreadcrumbs } from '../../actions/UpdateBreadcrumbsAction';
import { appStore } from '../../AppStore';
import { addQuery, SpacesSiteUrls } from '../../spaces/SpacesSiteUrls';
import { BreadcrumbStateInfo } from './BreadcrumbStateInfo';

export function populateContentBreadcrumbs(contentPath: ISpaceTypeInfo[], siteUrls: SpacesSiteUrls) {
  if (!siteUrls) {
    return;
  }

  let rootHref = addQuery(siteUrls.exploreUrl());

  const rootBreadcrumb: BreadcrumbStateInfo = {
    id: getPathFromUrl(rootHref),
    text: Messages.explore(),
    href: rootHref,
    testId: 'breadcrumb-content-root'
  };

  const contentBreadcrumbs: BreadcrumbStateInfo[] = contentPath.map(item => {
    const href = ContentSpaceDefinitions[item.contentType].contentSpaceUrl(siteUrls, item.id);
    return {
      id: getPathFromUrl(href),
      text: item.name,
      href: href,
      testId: `breadcrumb-${item.contentType}-${item.id}`
    };
  });


  appStore.dispatch(updateBreadcrumbs([].concat(rootBreadcrumb).concat(contentBreadcrumbs)));
}

export function addContentTypeToProjectHierarchy(projectHierarchy: INamedItemInfo[]): ISpaceTypeInfo<'project'>[] {
  if (!projectHierarchy){
    return [];
  }

  return projectHierarchy.map(project => {
    const ret: ISpaceTypeInfo<'project'> = {
      ...project,
      contentType: 'project'
    };
    return ret;
  });
}

export function watchUrlForBreadcrumbUpdates(
  $scope: ng.IScope,
  $location: ng.ILocationService,
  shouldUpdate: () => boolean
) {
  $scope.$watch(() => $location.url(), () => {
    if (shouldUpdate()) {
      appStore.dispatch(updateBreadcrumbHref($location.absUrl()));
    }
  });
}
